import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CartItem } from 'src/app/modals/cart-item';
import { Product } from 'src/app/modals/product.model';
import { EcommService } from 'src/app/services/ecomm.service';
import { ItemsService } from 'src/app/services/items.service';
import { constApi } from 'src/environments/constApi';
import { CartDialogComponent } from '../pages/cart-dialog/cart-dialog.component';
import { AuthService } from '../shared/services/auth.service';
import { CartService } from '../shared/services/cart.service';
import { EnumService } from '../shared/services/enum.service';
import { SidenavMenu } from '../shared/sidebar/sidebar-menu.model';
import { SidebarMenuService } from '../shared/sidebar/sidebar-menu.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main-v2',
  templateUrl: './main-v2.component.html',
  styleUrls: ['./main-v2.component.sass']
})
export class MainV2Component implements OnInit {
  public sidenavMenuItems: Array<any>;

  public currencies = ["USD", "EUR"];
  public currency: any;
  public flags = [
    { name: "English", image: "assets/images/flags/gb.svg" },
    { name: "German", image: "assets/images/flags/de.svg" },
    { name: "French", image: "assets/images/flags/fr.svg" },
    { name: "Russian", image: "assets/images/flags/ru.svg" },
    { name: "Turkish", image: "assets/images/flags/tr.svg" },
  ];
  public flag: any;

  products: Product[];

  indexProduct: number;
  shoppingCartItems: CartItem[] = [];

  nombreUsuario: any = "";

  public banners = [];

  wishlistItems: Product[] = [];
  fbBuscador: FormGroup;
  public url: string;
  navItems: SidenavMenu[] = [
    {
      displayName: "Inicio",
      iconName: "home",
      route: "/home/five",
    },
  ];

  menu: any[] = [];
  menuPrincipal: any[] = [];
  isLogin: boolean = false;
  valuesEcom: any[] = [];
  isLoad: boolean = true;
  resultBusquedaList: any[] = [];
  constructor(
    public router: Router,
    private cartService: CartService,
    public sidenavMenuService: SidebarMenuService,
    private enumService: EnumService,
    private ecomService: EcommService,
    public authService: AuthService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private itemServices: ItemsService,
    private dialog: MatDialog
  ) {
    this.cartService
      .getItems()
      .subscribe(
        (shoppingCartItems) => (this.shoppingCartItems = shoppingCartItems)
      );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    });
    this.getMenu();
  }

  ngAfterViewChecked() {}
  buildForm() {
    this.fbBuscador = this.fb.group({
      criterio: [""],
    });
  }
  ngAfterViewInit() {
    //#region
    // //////console.log(window.scroll(0,0));
    // window.scroll({
    //   top: 100,
    //   left: 100,
    //   behavior: 'smooth'
    // });
    // let top = document.getElementById('top');
    // if (top !== null) {
    //   top.scrollIntoView();
    //   top = null;
    // }
    //#endregion
  }

  ngOnInit() {
    this.buildForm()
    this.currency = this.currencies[0];
    this.flag = this.flags[0];
    this.authService.showUserRegister.subscribe((res: boolean) => {
      this.isLogin = res;
      if (this.isLogin) {
        this.getNombreUsuario();
      }
    });

    this.getValEcom();
  }
  ngDoCheck(): void {
    if (this.isLoad) {
      this.isLoad = false;
      if (this.authService.isLogin()) {
        this.isLogin = true;
        this.getNombreUsuario();
      } else {
        this.isLogin = false;
      }
    }
  }
  getNombreUsuario() {
    let usuario: any = JSON.parse(sessionStorage.getItem("tk"));
    if(usuario != null)
    this.nombreUsuario =
      "BIENVENIDO " + usuario.NombreUsr.split("/")[1].split(",")[1];
  }
  getValEcom() {
    let param = [{ clave: "Tipo", valor: "VALECOM" }];
    this.ecomService
      .getParam(environment.apiUrlAdm,constApi.ENUMTIPO, param)
      .subscribe((res: any) => {
        this.valuesEcom = res.filter((x) => x.ValorI == 1);
      });
  }
  getMenu() {
    this.enumService.getMenu("cat").subscribe((res: any) => {
      // this.menu = res;
      let menu: any = res;
      // this.menu = [];
      if (res.length) {
        res.forEach((el) => {
          this.menu = [];
          if (el.menusECat_List.length) {
            el.menusECat_List.forEach((el2) => {
              this.menu.push({
                displayName: el2.DenoCat,
                disabled: false,
                iconName: el2.IconMenuECat,
                route: "home/products/" + el2.Codigo + "/0/0/TODAS/0/0/1",
                children: [],
              });
            });
          }
          this.menuPrincipal.push({
            displayName: el.TituloMenuE,
            disabled: false,
            iconName: el.IconMenuE,
            route: "",
            children: this.menu,
          });
        });
        this.navItems.push({
          displayName: "Categorias",
          iconName: "dashboard",
          route: "",
          children: this.menuPrincipal,
        });
        this.navItems.push({
          displayName: "Nuestras Tiendas",
          iconName: "store",
          route: "/pages/contact",
          children: [],
        });
      }
    });
  }
  public changeCurrency(currency) {
    this.currency = currency;
  }
  public changeLang(flag) {
    this.flag = flag;
  }
  irAcuenta(){
    // this.spinner.show()
    this.router.navigate(["/pages/userAcc"]);
  }
  irMiAcuenta(){
    // this.spinner.show()
    this.router.navigate(["/pages/my-account"]);
    this.spinner.show()
  }
  public salirCuenta() {
    this.authService.showUserRegister.emit(false);
    this.isLogin = false;
    this.router.navigate([""]);
    sessionStorage.removeItem("dataPedido")
    this.authService.exitAccount();
  }
  irApedido(){
    this.router.navigate(["/pages/pedidos"]);
  }
  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }
  buscarItems() {
    if (this.fbBuscador.get("criterio").value.length >= 3) {
      let param: any;
      if (!isNaN(this.fbBuscador.get("criterio").value)) {
        param = [
          {
            keyparam: "CodigoBarras",
            valueparam: this.fbBuscador.get("criterio").value,
          },
        ];
      } else {
        param = [
          {
            keyparam: "NombreItm",
            valueparam: this.fbBuscador.get("criterio").value,
          },
        ];
      }
      this.itemServices.itemsList(param).subscribe((res: any) => {
        this.resultBusquedaList = res;
      });
    }
  }
  seleccionarItem() {
    let paramNomItem = {
      param1: "",
      param2: "",
      param3: "",
    };
    sessionStorage.setItem("paramFilter", JSON.stringify(paramNomItem));
    this.router.navigate([
      "/home/products",
      0,
      this.fbBuscador.get("criterio").value.length == 0 ? '0' : this.fbBuscador.get("criterio").value,
      0,
      "TODAS",
      0,
      0,
      1,
    ]);
  }
  abrirDialogCart() {
    this.dialog.open(CartDialogComponent, {
      data: null,
      panelClass: "product-dialog",
      width: "800px",
      // height: "100%",
      // position: {
      //   right: "0",
      // },
    });
  }

}
